import { useMutation } from '@tanstack/react-query';

import { getJwt } from '@jane/shared/auth';

import { janeApi } from '../api/janeApi';
import type { ApiRequestError } from '../types/apiResponseError';

export type LinkSource = 'email' | 'kiosk' | 'sms';

const updateCheckoutPayment = async ({
  aeropayBankId,
  cartUuid,
  currentUrl,
  jDeviceId,
  linkSource,
  tipAmount,
}: {
  aeropayBankId: number;
  cartUuid: string;
  currentUrl: string;
  jDeviceId: string;
  linkSource: LinkSource;
  tipAmount: number;
}) => {
  const response = await janeApi.patch<null>(
    `/users/reservations/${cartUuid}/payment`,
    {
      payment_data: {
        aeropay_bank_account_id: aeropayBankId,
        current_url: currentUrl,
        j_device_id: jDeviceId,
        link_source: linkSource,
        tip_amount: tipAmount,
      },
    },
    getJwt()
  );
  return response;
};

export const useUpdateCheckoutPayment = ({
  onError,
}: {
  onError?: (err: ApiRequestError) => void;
}) => {
  return useMutation({
    mutationFn: updateCheckoutPayment,
    onError,
  });
};
